/** Stable `flow` tag values for GlitchTip session context (active chatbot scenario). */
export enum ErrorTrackingFlow {
  Mocked = 'mocked',
  OpenLiveChat = 'open_live_chat',
  FailedKyc = 'failed_kyc',
  SelectedEntity = 'selected_entity',
  ResumeAi = 'resume_ai',
  PredictiveSuggestions = 'predictive_suggestions',
  Landing = 'landing',
  CategoryBrowsing = 'category_browsing',
  Ai = 'ai',
  /** Live-agent chat create (`PleasedClient.chat().create()`). */
  OpenChat = 'open_chat',
  /** Resume / intervene via `loadExistingChat`. */
  OpenChatLoad = 'open_chat_load',
}

/** Stable `event` tag values for GlitchTip / captureException (fault location). */
export enum ErrorTrackingEvent {
  WidgetInitAuth = 'widget_init_auth',
  WidgetInit = 'widget_init',
  WidgetBootstrap = 'widget_bootstrap',
  /** Host passed a config the widget cannot load with (invalid client url / widget id). */
  WidgetLoad = 'widget_load',
  /** Loader started the widget for a client whose chat widget is turned off. */
  WidgetDisabled = 'widget_disabled',
  MaintenanceSetup = 'maintenance_setup',
  ChatbotFlowStart = 'chatbot_flow_start',
  /** Default chatbot flow event handler failed after start (`useFlowEventHandlers`). */
  ChatbotFlowAction = 'chatbot_flow_action',
  /** Connect-to-agent wizard step failed (`ConnectRequestEvent`). */
  ConnectRequest = 'connect_request',
  /** Queued chatbot message never rendered — its typing bubble was dropped (`conversation.enqueue`). */
  ChatbotMessageQueue = 'chatbot_message_queue',
  ChatbotPredictiveOptions = 'chatbot_predictive_options',
  PredictiveSuggestion = 'predictive_suggestion',
  AiChatCreation = 'ai_chat_creation',
  AiFlow = 'ai_flow',
  AiResponseError = 'ai_response_error',
  /** Live-agent chat create (`PleasedClient.chat().create()`). */
  OpenChat = 'open_chat',
  /** Resume / intervene via `loadExistingChat`. */
  OpenChatLoad = 'open_chat_load',
  /** Firebase sync of an already connected live chat (listeners, presence, typing). */
  ChatFirebaseSync = 'chat_firebase_sync',
  /** Visitor message / file that never reached the agent. */
  ChatMessageSend = 'chat_message_send',
  /** Guest form / OTP / guest open-request ticket (`GuestForm.vue`). */
  GuestForm = 'guest_form',
  /** Hybrid/host login or `widget:re_auth` token resolution (`LoginForm`, `useBotUser`, bridge). */
  WidgetAuth = 'widget_auth',
  /** CSAT feedback POST failed (`NewCsat.vue`). */
  CsatSubmit = 'csat_submit',
  /** Standalone article route failed to load details (`Article.vue`). */
  ArticleLoad = 'article_load',
  /** Landing Voice AI session error (`ChatInteraction.vue`). */
  LandingVoiceAi = 'landing_voice_ai',
  /**
   * Init parallel prefetch failed without aborting startFlow (open chats / resume AI query).
   * Routing continues as if there was nothing to resume.
   */
  ChatbotInitPrefetch = 'chatbot_init_prefetch',
  /** Host started Failed KYC without a usable `failedKycMessage` (misconfiguration, not a mid-flow crash). */
  FailedKycConfig = 'failed_kyc_config',
}
